import './SkeletonAvatar-e00fff32.css';

var classes = {"SkeletonAvatar":"prc-Skeleton-SkeletonAvatar-TYNvX"};

export { classes as default };
